import { FormFlowContext } from "modules/forms/context/FormFlowContext";
import { useContext } from "react";

export default function useFormFlow() {
    return useContext(FormFlowContext);
}